import keyBy from 'lodash/keyBy';

import { DateVariant, Stack, Switch, Typography } from '@lyearn/ui';
import { Field, FieldType } from '@/components/Form';
import { DatabaseFieldEditorConfig } from '@/modules/corporate/modules/database/fields/types';

import * as FieldUtils from '../../utils/editor/config';
import { fieldSettingsSectionStyles } from '../../utils/editor/styles';

const DateFieldEditorConfig: DatabaseFieldEditorConfig = {
  getFieldSettingsFormProps: ({ t, allowPartialUpdates }) => {
    const fields: Field[] = [
      FieldUtils.getDatabaseTypeFormField(t, allowPartialUpdates),
      {
        name: 'metadataField.dateFormat',
        type: FieldType.Custom,
        Component: ({ value, onChange }) => {
          const _onChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
            onChange(checked ? DateVariant.DateAndTime : DateVariant.Date);
          };

          return (
            <Stack className="mb-8 ms-8" direction="row" gapX={12} justifyContent="between">
              <Typography color="text-text-primary" variant="body-short-02">
                {t('Database:Date.IncludeTime')}
              </Typography>
              <Switch
                checked={value === DateVariant.DateAndTime ? true : false}
                className="flex-shrink-0"
                onChange={_onChange}
              />
            </Stack>
          );
        },
      },
      FieldUtils.getRequiredFormField(t),
      FieldUtils.getDescriptionEnabledFormField(t),
    ];

    return {
      fields: keyBy(fields, 'name'),
      sectionLayout: [
        {
          id: 'date-settings',
          className: fieldSettingsSectionStyles(24),
          layout: ['metadataField.type', 'metadataField.dateFormat'],
        },
        {
          id: 'number-field-view-settings',
          className: fieldSettingsSectionStyles(24),
          layout: ['viewField.required', 'viewField.descriptionEnabled'],
        },
      ],
      overrides: FieldUtils.FormOverrides,
    };
  },
  getFieldSettingsFormInitialValues: ({ metadataField, viewField }) => ({
    metadataField: {
      type: metadataField.type,
      dateFormat: metadataField.dateFormat,
      validation: metadataField.validation,
    },
    viewField: { required: viewField.required, descriptionEnabled: viewField.descriptionEnabled },
  }),
  adaptEditorFormField: ({ t, field }) => {
    return {
      placeholder:
        field.metadataField.dateFormat === DateVariant.DateAndTime
          ? t('Common:SelectDateAndTime')
          : t('Common:SelectDate'),
      rendererProps: {
        variant: field.metadataField.dateFormat,
      },
    };
  },
};

export default DateFieldEditorConfig;
